import React, { useState } from "react";
import S from "../AllEvents.styled";
import NewsCard from "@/components/global-components/NewsCard";
import Arrow from "@/assets/arrow-down.svg";
import EventCard from "@/components/global-components/EventCard";

interface PaginationProps {
  items: any[];
  type: string;
}

const PaginationComponent: React.FC<PaginationProps> = ({ items, type }) => {
  const itemsPerPage = 9;
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = items.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(items.length / itemsPerPage);

  const handlePageChange = (newPage: number) => {
    setCurrentPage(newPage);
  };

  const handlePrevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
  };

  return (
    <>
      {type === "news" ? (
        <S.CardsWrapper>
          {currentItems?.map(({ title, uri, newsInfo, date }, index) => {
            return (
              <NewsCard
                type="small"
                key={index}
                title={title}
                uri={uri}
                date={date}
                newsInfo={newsInfo}
              />
            );
          })}
        </S.CardsWrapper>
      ) : (
        <S.CardsWrapper>
          {currentItems?.map(({ title, uri, eventsInfo }, index) => {
            return (
              <EventCard
                type="small"
                key={index}
                eventsInfo={eventsInfo}
                title={title}
                uri={uri}
                hasThumbnail={"image"}
              />
            );
          })}
        </S.CardsWrapper>
      )}

      {totalPages > 1 && (
        <S.Pagination>
          <S.ArrowLeft onClick={handlePrevPage} disabled={currentPage === 1}>
            {<Arrow />}
            <span className="hide-in-mobile">Föregående</span>
          </S.ArrowLeft>
          {totalPages === 1 ? (
            <S.PageBtn
              onClick={() => handlePageChange(1)}
              $active={currentPage === 1}
            >
              {1}
            </S.PageBtn>
          ) : totalPages <= 3 ? (
            [...Array(totalPages)].map((_, index) => (
              <S.PageBtn
                key={index}
                onClick={() => handlePageChange(index + 1)}
                $active={currentPage === index + 1}
              >
                {index + 1}
              </S.PageBtn>
            ))
          ) : currentPage <= 3 ? (
            <>
              {[...Array(3)].map((_, index) => (
                <S.PageBtn
                  key={index}
                  onClick={() => handlePageChange(index + 1)}
                  $active={currentPage === index + 1}
                >
                  {index + 1}
                </S.PageBtn>
              ))}
              <S.Dots>...</S.Dots>
              <S.PageBtn
                onClick={() => handlePageChange(totalPages)}
                $active={currentPage === totalPages}
              >
                {totalPages}
              </S.PageBtn>
            </>
          ) : currentPage >= totalPages - 2 ? (
            <>
              <S.PageBtn
                onClick={() => handlePageChange(1)}
                $active={currentPage === 1}
              >
                {1}
              </S.PageBtn>
              <S.Dots>...</S.Dots>
              {[...Array(3)].map((_, index) => (
                <S.PageBtn
                  key={index}
                  onClick={() => handlePageChange(totalPages - 2 + index)}
                  $active={currentPage === totalPages - 2 + index}
                >
                  {totalPages - 2 + index}
                </S.PageBtn>
              ))}
            </>
          ) : (
            <>
              <S.PageBtn
                onClick={() => handlePageChange(1)}
                $active={currentPage === 1}
              >
                {1}
              </S.PageBtn>
              <S.Dots>...</S.Dots>
              {[...Array(3)].map((_, index) => (
                <S.PageBtn
                  key={index}
                  onClick={() => handlePageChange(currentPage - 2 + index)}
                  $active={currentPage === currentPage - 2 + index}
                >
                  {currentPage - 2 + index}
                </S.PageBtn>
              ))}
              <S.Dots>...</S.Dots>
              <S.PageBtn
                onClick={() => handlePageChange(totalPages)}
                $active={currentPage === totalPages}
              >
                {totalPages}
              </S.PageBtn>
            </>
          )}
          <S.ArrowRight
            onClick={handleNextPage}
            disabled={currentPage === totalPages}
          >
            <span className="hide-in-mobile">Nästa</span>
            <Arrow />
          </S.ArrowRight>
        </S.Pagination>
      )}
    </>
  );
};

export default PaginationComponent;
